import { render, staticRenderFns } from "./TermOfPaymentComponent.vue?vue&type=template&id=cf206236"
import script from "./TermOfPaymentComponent.vue?vue&type=script&lang=js"
export * from "./TermOfPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports